import { formatRate } from '@leland-dev/leland-ui-library';
import React from 'react';

interface ReviewDimensionProps {
  rate?: Nullable<number>;
  dimension: string;
}

const ReviewDimension: React.FC<ReviewDimensionProps> = ({
  rate,
  dimension,
}) => {
  return rate && rate != 0 ? (
    <div className="flex w-full items-center space-x-9">
      <h2 className="grow whitespace-nowrap text-lg font-medium leading-6 text-leland-gray-dark">
        {dimension}
      </h2>
      <div className="flex items-center space-x-1.5">
        <div className="h-1.5 w-28 rounded-full bg-leland-gray-stroke">
          <div
            className="h-full rounded-full bg-leland-gray-dark"
            style={{ width: `${(rate / 5) * 100}%` }}
          />
        </div>
        <p className="text-lg text-leland-gray-dark">{formatRate(rate)}</p>
      </div>
    </div>
  ) : null;
};

export default ReviewDimension;
